var {AmpersandView} = require('catalog/libs');

/**
 * Catalog Listing Marquee View.
 *
 * @class CatalogListingMarqueeView
 * @constructor
 */
var CatalogListingMarqueeView = AmpersandView.extend({
    initialize: function () {
        //Initializing view
        // hpe.log('CatalogListingMarqueeView');
    }
});

module.exports = {CatalogListingMarqueeView};
